module.exports = __webpack_public_path__ + "img/banner-21.aea6ac79.jpg";